import { render, staticRenderFns } from "./FileUuidDownloadLink.vue?vue&type=template&id=00fe7652"
import script from "./FileUuidDownloadLink.vue?vue&type=script&lang=js"
export * from "./FileUuidDownloadLink.vue?vue&type=script&lang=js"
import style0 from "./FileUuidDownloadLink.vue?vue&type=style&index=0&id=00fe7652&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports